export default __webpack_public_path__ + "static/Plots0007-7bcb23bc82813058bc8dc02037e742ff.jpg";